module.exports = fox._r("images/icon-3.png", __webpack_public_path__ + "images/icon-3.png");


//////////////////
// WEBPACK FOOTER
// ./images/icon-3.png
// module id = 166
// module chunks = 5